import {Inject, Injectable, PLATFORM_ID} from '@angular/core';

import {getAllStorageKeys, PersistentStorageKeys, StorageKeyTargetController, StorageKeyType, StorageType} from './types';

@Injectable({
	providedIn: 'root',
})
export class StorageService {
	private StorageKeyTargetController: StorageKeyTargetController;
	/* -------------------------------------------------------------------------------------------------------------- */
	private _initialized = false;
	public init(): void {
		if (this._initialized) return;
		this._initialized = true;
		this.StorageKeyTargetController = new StorageKeyTargetController(this);
	}

	constructor(@Inject(PLATFORM_ID) public platformId: object) {}
	/* -------------------------------------------------------------------------------------------------------------- */
	private getStorage(storageType: StorageType): Storage {
		switch (storageType) {
			case StorageType.LOCAL:
				return localStorage;
			case StorageType.SESSION:
				return sessionStorage;
			default:
				return undefined;
		}
	}

	private getStorageOf(key: StorageKeyType): Storage {
		const storageType: StorageType = this.getKeyStorageType(key);
		switch (storageType) {
			case StorageType.LOCAL:
				return localStorage;
			case StorageType.SESSION:
				return sessionStorage;
			default:
				return undefined;
		}
	}

	private getKeyStorageType(key: StorageKeyType): StorageType {
		if (!this.StorageKeyTargetController) this.init();
		return this.StorageKeyTargetController?.storageTypesMap.get(key) || undefined;
	}

	has(key: StorageKeyType): boolean {
		return this.getKeyStorageType(key) !== undefined;
	}

	get<T>(key: StorageKeyType): T {
		const storage: Storage = this.getStorageOf(key);
		if (!storage) return undefined;
		const item: string = storage.getItem(key);
		return JSON.parse(item);
	}

	set<T>(key: StorageKeyType, value: T, targetStorage?: StorageType): void {
		//const storage: Storage = this.getStorage(targetStorage) || this.getStorageOf(key);
		const storage: Storage = targetStorage ? this.getStorage(targetStorage) : this.getStorageOf(key);
		if (!storage) return;
		const item: string = JSON.stringify(value);
		storage.setItem(key, item);
	}

	remove(key: StorageKeyType): void {
		const storage: Storage = this.getStorageOf(key);
		if (!storage) return;
		storage.removeItem(key);
	}

	clearAll(): void {
		localStorage.clear();
		sessionStorage.clear();
	}

	/* -------------------------------------------------------------------------------------------------------------- */
	private resetSessionKeys(): void {
		const allKeys: StorageKeyType[] = getAllStorageKeys();
		const persistentKeys: StorageKeyType[] = PersistentStorageKeys;
		allKeys.forEach(key => {
			if (persistentKeys.includes(key)) return;
			sessionStorage.removeItem(key);
		});
	}
}
